module.exports = __webpack_public_path__ + "img/phone-icon.94cdaf9d.svg";